import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

const members = [
  {
    name: 'Priya Mehta',
    discipline: 'Visual Arts',
    score: 912,
    location: 'Mumbai',
    since: '2025',
    photo: 'https://images.unsplash.com/photo-1594540637720-9b14714212f4?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Arjun Bhatia',
    discipline: 'Film & Direction',
    score: 847,
    location: 'Delhi',
    since: '2025',
    photo: 'https://images.unsplash.com/photo-1754473397061-e18dc1091855?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Nandini Rao',
    discipline: 'Classical Music',
    score: 960,
    location: 'Chennai',
    since: '2025',
    photo: 'https://images.unsplash.com/photo-1536766768598-e09213fdcf22?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Kabir Saxena',
    discipline: 'Literature & Poetry',
    score: 823,
    location: 'Jaipur',
    since: '2026',
    photo: 'https://images.unsplash.com/photo-1650034925656-001a41d7e65b?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Zara Sheikh',
    discipline: 'Theatre & Performance',
    score: 891,
    location: 'Hyderabad',
    since: '2025',
    photo: 'https://images.unsplash.com/photo-1565751303176-28a5b3cebc76?w=200&h=200&fit=crop&crop=face',
  },
  {
    name: 'Dev Kulkarni',
    discipline: 'Digital Art & Design',
    score: 778,
    location: 'Pune',
    since: '2026',
    photo: 'https://images.unsplash.com/photo-1641108001784-cdf7d87b353f?w=200&h=200&fit=crop&crop=face',
  },
];

const scoreColor = (score) => {
  if (score >= 900) return '#1A6B3C';
  if (score >= 800) return '#0F1B2D';
  return '#C4A35A';
};

const scoreLabel = (score) => {
  if (score >= 900) return 'Exceptional';
  if (score >= 800) return 'Excellent';
  return 'Good';
};

const MembersSection = () => {
  return (
    <section
      className="section-padding relative"
      data-testid="members-section"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <p className="section-label mb-5">Verified Members</p>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-semibold text-[#0F1B2D] tracking-tight">
            Some of our accredited professionals
          </h2>
          <p className="text-sm text-[#9B9589] font-medium mt-3 max-w-lg mx-auto">
            Every member is independently verified. Trust Scores reflect real professional conduct.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {members.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              viewport={{ once: true }}
              className="inst-card rounded-lg p-6"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-11 h-11 rounded-full object-cover flex-shrink-0 border-2 border-[#E8E4DE]"
                  />
                  <div>
                    <p className="text-sm font-semibold text-[#0F1B2D]">{member.name}</p>
                    <p className="text-[11px] text-[#9B9589] font-medium">{member.discipline}</p>
                  </div>
                </div>
                <Shield size={16} className="text-[#C4A35A] flex-shrink-0 mt-1" />
              </div>

              <div className="flex items-end justify-between pt-3 border-t border-[#E8E4DE]">
                <div>
                  <p className="text-[9px] uppercase tracking-[0.2em] text-[#9B9589] font-bold">Trust Score</p>
                  <div className="flex items-center gap-2">
                    <span className="font-['Playfair_Display'] text-xl font-semibold" style={{ color: scoreColor(member.score) }}>
                      {member.score}
                    </span>
                    <span
                      className="text-[9px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full"
                      style={{
                        color: scoreColor(member.score),
                        backgroundColor: `${scoreColor(member.score)}10`,
                      }}
                    >
                      {scoreLabel(member.score)}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-[9px] text-[#9B9589] font-medium">{member.location}</p>
                  <p className="text-[9px] text-[#9B9589] font-medium">Since {member.since}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MembersSection;
